import { Controller } from "@hotwired/stimulus";

/*
 * A polyfill helper for toggling popovers, used in dropdown menus for browsers
 * lacking popover support.
 *
 * @see {templates/macros/dropdown.html}
 */
export default class extends Controller {
  static targets = ["popover"];
  connect() {
    const el = this.popoverTarget;
    el.classList.add("d-none", "position-absolute");
  }
  toggle(event) {
    const el = this.popoverTarget;
    el.classList.toggle("d-none");
    // button styling
    event.currentTarget.classList.toggle("popover-state-open");
  }
}
